<template>
  <el-dialog
    :title="typeTitle === 'add' ? '新增问卷' : '修改问卷'"
    :visible.sync="dialogVisible"
    width="520px"
    :close-on-click-modal="false"
    :before-close="handleClose"
  >
    <el-form
      ref="formRef"
      :model="form"
      :rules="surveyRules"
      label-width="110px"
    >
      <el-form-item label="问卷名称版本" prop="title">
        <el-input v-model="form.title" placeholder="请输入问卷名称版本"></el-input>
      </el-form-item>
      <el-form-item label="生效范围" prop="communityUuid">
          <el-select v-model="form.communityUuid" placeholder="请选择小区" filterable clearable style="width: 100%">
              <el-option v-for="item in communityList" :key="item.uuid" :label="item.name" :value="item.uuid"/>
          </el-select>
      </el-form-item>
      <el-form-item v-if="typeTitle === 'edit'" label="状态" prop="status">
        <el-radio-group v-model="form.status">
          <el-radio :label="801201">生效</el-radio>
          <el-radio :label="801202">停用</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="备注">
        <el-input v-model="form.comment" type="textarea" :rows="3" placeholder="请输入备注"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleSubmit">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import { getCommunityListApi,} from "@/api/publish";
  import {addFeedbackApi} from "@/api/online-survey";
  import {MessageError, MessageWarning,MessageSuccess} from "@custom/message";
  import { detailFeedbackApi,updateFeedbackApi } from "@/api/online-survey";
  // import { updateAticity } from "@/api/";
export default {
      name: "layer-survey-dialog",
      data() {
        return {
            dialogVisible: false,
            typeTitle:"add",
            form:{
              title:"",
              communityUuid:"",
              status:801201,
              comment:"",
            },
            surveyRules: {
              title: [{ required: true, message: '请输入问卷名称版本', trigger: 'blur' }],
              communityUuid: [{ required: true, message: '请选择生效范围', trigger: 'change' }],
              status: [{ required: true, message: '请选择状态', trigger: 'change' }]
            },
            communityList: [],
            uuid:"",//当前行uuid
        }
    },
  props: {
    scopeOptions: { type: Array, default: () => [] }
  },
  computed: {
  },
  methods: {
    handleClose() {
      this.dialogVisible = false;
      this.form ={title:"",communityUuid:"",status:801201,comment:"",}
    },
    handleSubmit() {
      this.$refs.formRef.validate(valid => {
        if (valid) {
          const { title, communityUuid, status, comment } = this.form
          // 基础参数
          let params = {
            title,
            communityUuid,
            status,
            comment,
            nodeType: 801251, //标题
          }
          const loading = this.$loading({ lock: true, text: 'Loading', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)' });

          // 判断是否编辑：存在uuid则走更新接口，否则新增
          if (this.typeTitle !=='add') {
            // 修改追加uuid参数
            params.uuid = this.uuid
            updateFeedbackApi(params)
              .then(res => {
                MessageSuccess('修改成功');
                this.handleClose();
                this.$emit('handleSearch');
              })
              .catch(err => {
                // 可选：失败提示
                MessageError('修改失败')
              })
              .finally(() => loading.close());
          } else {
            addFeedbackApi(params)
              .then(res => {
                MessageSuccess('添加成功');
                this.handleClose();
                this.$emit('handleSearch');
              })
              .catch(err => {
                MessageError('添加失败')
              })
              .finally(() => loading.close());
          }
        }
      })
    },
    async openDialog(type,row) {
        const that = this;
        console.log('row',row);
        this.uuid = row.uuid
        this.typeTitle = type;
        if(this.typeTitle !=='add'){
        await  this.handleSurveyInfo();
        }

        that.dialogVisible = true;
    }, 
    // 请求问卷详情
   async handleSurveyInfo() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
    await  detailFeedbackApi({ uuid: this.uuid })
        .then(res => {
          this.form.comment = res.info.comment;
          this.form.title = res.info.title;
          this.form.communityUuid = res.info.communityUuid;
          this.form.status = res.info.status;
          // 后端返回作答数据后赋值 answerMap
          // this.answerMap = {
          //   填空uuid: "文字",
          //   单选uuid: "A.xxx",
          //   多选uuid: ["A.xxx", "B.xxx"]
          // }
          loading.close()
        })
        .catch(() => loading.close());
    },   
  },
  mounted() {
      getCommunityListApi().then(res => {
          this.communityList = res.list;
       });
  },
}
</script>
